import { render, staticRenderFns } from "./ToDoManagerForm.vue?vue&type=template&id=3d3729fa&"
import script from "./ToDoManagerForm.vue?vue&type=script&lang=js&"
export * from "./ToDoManagerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports